import gql from "graphql-tag";

// Query
export const GET_BALANCE = gql`
  query balance($id: ID!) {
    balance(id: $id) {
      waiting_funds {
        amount
      }
      available {
        amount
      }
      transferred {
        amount
      }
    }
  }
`;
